<template>
  <div>
    <form @submit.prevent="previewGL">
      <modal v-show="isModalVisible" @close="closeModal" footer>
        <template v-slot:title>
          <h5>Update GL account</h5>
        </template>
        <template v-slot:body>
          <div class="form-group">
            <label for="status">Status</label> <br />
            <select
              id="select"
              class="form-select fw-two form-control"
              v-model="gl.status"
            >
              <option value="" selected disabled>Please Select...</option>
              <option value="active" class="mb-2">Active</option>
              <option value="in-active" class="mb-2">
                In Active
              </option>
            </select>
          </div>
          <div class="form-group">
            <label for="status">Method</label> <br />
            <select
              id="select"
              class="form-select fw-two form-control"
              v-model="gl.method"
            >
              <option value="" selected disabled>Please Select...</option>
              <option value="bills-payment" class="mb-2">Bills Payment</option>
              <option value="pos-settlement" class="mb-2">
                POS Settlement
              </option>
            </select>
          </div>
          <div class="form-group">
            <label for="">Debit Code</label>
            <input
              type="text"
              class="form-control"
              placeholder="Debit Code"
              name="Debit Code"
              @keypress="isNumber($event)"
              v-model="gl.debit_code"
            />
          </div>
          <div class="form-group">
            <label for="">Credit Code</label>
            <input
              type="text"
              class="form-control"
              placeholder="Credit Code"
              name="Credit Code"
              @keypress="isNumber($event)"
              v-model="gl.credit_code"
            />
          </div>
          <div class="form-group">
            <label for="title">Account Account</label>
            <input
              type="text"
              class="form-control"
              placeholder="Account Nummber"
              name="title"
              maxlength="10"
              @keyup="trackAccountNumber"
              @keypress="isNumber($event)"
              v-model="gl.account_number"
            />
            <span v-if="enquiryLoading" class="text-primary"
              >Please wait...</span
            >
          </div>
          <div class="form-group">
            <label for="title">Account Name</label>
            <input
              type="text"
              placeholder="Acccount Name"
              disabled
              class="form-control"
              name="title"
              v-model="gl.account_name"
            />
          </div>
        </template>
        <template v-slot:footer>
          <button
            type="submit"
            class="button"
            :disabled="!glFormIsValid || loading"
          >
            <span class="custom-loader" v-if="loading">
              <loader-icon size="1.5x" class="custom-class"></loader-icon>
              <span style="font-weight: 600; text-transform: initial;"
                >Please wait...</span
              >
            </span>
            <span v-else>
              Update GL
            </span>
          </button>
          <button
            type="button"
            class="btn btn-secondary"
            data-dismiss="modal"
            @click="closeModal"
          >
            Cancel
          </button>
        </template>
      </modal>
    </form>

    <div
      v-if="pageLoading"
      style="display: flex; top: 0px; position: fixed; left: 0px; right: 0px; bottom: 0px; background-color: rgba(247, 247, 247, 0.9); z-index: 9999; justify-content: center; align-items: center;"
    >
      <div>
        <div>
          <h3>Getting GLs ready...</h3>
        </div>
      </div>
    </div>
    <div v-else>
      <div class="row align-items-center justify-content-between mb-2">
        <div class="col">
          <h1 class="mb-2 font-regular">GL Accounts</h1>
        </div>
      </div>

      <div class="card card--no-shadow">
        <div class="card-header">
          <slot name="header">
            <h4 class="card-title">Gl Accounts</h4>
          </slot>
        </div>
        <div class="card-content">
          <div class="card-body">
            <CDataTable
              :items="gls"
              :fields="fields"
              :items-per-page="small ? 10 : 5"
              pagination
              sorter
              tableFilter
            >
              <template #updated_at="{item}">
                <td class="table--action-mobile">
                  {{ item.updated_at | date }}
                </td>
              </template>
              <template #created_at="{item}">
                <td class="table--action-mobile">
                  {{ item.created_at | date }}
                </td>
              </template>
              <template #balance="{item}">
                <td
                  class="table--action-mobile"
                  v-if="
                    permissions.includes('provider-balance') &&
                      permissions.includes('view-account-balance')
                  "
                >
                  <!-- {{ "5,000.00" }} -->
                  <button
                    @click="revealBalance(item.account_number)"
                    class="btn btn-primary"
                  >
                    View Balance
                  </button>
                </td>
              </template>
              <template #action="{item}">
                <td
                  class="table--action-mobile"
                  v-if="permissions.includes('update-gls')"
                >
                  <button
                    class="button btn-success"
                    style="background-color: #0bc681;"
                    @click="showUpdateModal(item)"
                  >
                    Update
                  </button>
                </td>
              </template>
            </CDataTable>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ApiService from "../../services/api.service";
import ErrorService from "../../services/error.service";
import Swal from "sweetalert2";
import CDataTable from "../../components/CDataTable.vue";
const fields = [
  "account_number",
  "account_name",
  "status",
  "balance",
  "method",
  "action"
];
export default {
  name: "GLAccount",
  components: {
    CDataTable
  },
  data() {
    return {
      fields,
      gls: [],
      small: true,
      gl: {
        account_number: "",
        account_name: "",
        method: "",
        status: ""
      },
      loading: false,
      pageLoading: false,
      isModalVisible: false,
      enquiryLoading: false
    };
  },
  computed: {
    permissions() {
      let permissions = this.$store.getters.permissions;
      return permissions;
    },
    formIsValid() {
      return (
        this.gl.type !== "" &&
        this.charge.amount !== "" &&
        this.charge.medium !== "" &&
        this.charge.min !== "" &&
        this.charge.max !== ""
      );
    },
    glFormIsValid() {
      return (
        this.gl.account_number.length === 10 &&
        this.gl.method !== "" &&
        this.gl.active !== "" &&
        this.gl.account_name !== ""
      );
    }
  },
  methods: {
    isNumber: function(evt) {
      evt = evt ? evt : window.event;
      var charCode = evt.which ? evt.which : evt.keyCode;
      if (
        charCode > 31 &&
        (charCode < 48 || charCode > 57) &&
        charCode !== 46
      ) {
        evt.preventDefault();
      } else {
        return true;
      }
    },
    trackAccountNumber() {
      console.log(this.gl.account_number);
      if (this.gl.account_number.length === 10) {
        this.getBankEnquiryName();
      } else {
        this.gl.account_name = "";
      }
    },
    async getBankEnquiryName() {
      let data = {
        account_number: this.gl.account_number
      };

      this.enquiryLoading = true;
      try {
        const res = await ApiService.post(
          "transfer/intra-bank-name-enquiry",
          data
        );
        this.gl.account_name = res.data.data.receiver_name;

        this.enquiryLoading = false;
      } catch (error) {
        console.log(error);
        this.enquiryLoading = false;
        let _error = error.response.data;
        ErrorService.displayErrorAlert(_error);
      }
    },
    showUpdateModal(item) {
      this.gl = Object.assign({}, item);
      this.isModalVisible = true;
    },
    openModal() {
      this.isModalVisible = true;
    },
    closeModal() {
      this.isModalVisible = false;
      this.gl.account_number = "";
      this.gl.account_name = "";
      this.status = "";
      this.method = "";
    },
    async getCharges() {
      try {
        this.pageLoading = true;
        const response = await ApiService.get("settings/gls");
        console.log(response.data);

        this.gls = response.data.data;
        this.pageLoading = false;
      } catch (error) {
        console.log(error.response);
        this.pageLoading = false;
      }
    },
    previewGL() {
      this.isModalVisible = false;
      const swalWithBootstrapButtons = Swal.mixin({
        customClass: {
          confirmButton: "btn btn-success",
          cancelButton: "btn btn-danger me-2",
          title: "text-center h6 fw-bold text-black d-block"
        },
        buttonsStyling: false
      });

      swalWithBootstrapButtons
        .fire({
          title: `Are you sure you want to update <span class="text-primary fw-bolder"> ${this.gl.account_number} </span> with account name <span class="text-primary"> ${this.gl.account_name} 
          </span> as your GL Account?`,
          text: "You won't be able to revert this!",
          icon: "warning",
          showCancelButton: true,
          confirmButtonText: "Yes, continue!",
          cancelButtonText: "No, cancel!",
          reverseButtons: true
        })
        .then(result => {
          if (result.isConfirmed) {
            this.isModalVisible = true;
            this.createUpdateCharges();
          } else if (result.dismiss == Swal.DismissReason.cancel) {
            // this.method = "cash";
            // this.amount = Number(this.orderDetails.balance_amount);
            this.closeModal();
            swalWithBootstrapButtons.fire(
              "Cancelled",
              "Your GL Account is safe",
              "error"
            );
          }
        });
    },
    async createUpdateCharges() {
      try {
        this.loading = true;
        const response = await ApiService.post("settings/gls/update", this.gl);
        this.loading = false;
        this.closeModal();
        Swal.fire({
          title: "Success",
          text: response.data.message,
          icon: "success",
          timer: 3000,
          confirmButtonText: "Close",
          showConfirmButton: false
        });
        this.getCharges();
      } catch (error) {
        this.closeModal();
        let _error = error.response.data;
        ErrorService.displayErrorAlert(_error);
        this.loading = false;
      }
    },
    async revealBalance(num) {
      this.accountLoading = true;
      try {
        let response = await ApiService.post(`account/balance`, {
          account_number: num
        });
        this.accountLoading = false;
        console.log(response);

        Swal.fire({
          title: "Account Balance",
          text: `₦${response.data.data.available_balance}`,
          icon: "success",
          confirmButtonText: "Ok"
        });
        // return response.data.data.available_balance;
      } catch (error) {
        console.log(error.response.data);
        return "Error Getting Balance";
        // this.accountLoading = false;
        // ErrorService.displayErrorAlert(error.response.data);
      }
    }
  },
  mounted() {
    this.getCharges();
  }
};
</script>
